import Swiper, { Pagination, EffectFade, Autoplay } from "swiper";

export default {
  init() {
    if (document.querySelector("#home-header-slider") !== null) {
      Swiper.use([Pagination, EffectFade, Autoplay]);

      document.querySelectorAll("#home-header-slider").forEach((el) => {
        const pagination = el.querySelector(".swiper-pagination");

        el.swiper = new Swiper(el, {
          // autoHeight: true,
          // checking if mobile, if so then allow touch else don't.
          allowTouchMove: (window.innerWidth < 1024),
          effect: "fade",
          loop: true,
          fadeEffect: {
            crossFade: true,
          },
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          on: {
            init: this.movePagination,
            slideChangeTransitionStart: this.movePagination,
          },
        });
      });
    }
  },
  movePagination() {
    const pagination = this.$el[0].querySelector(".swiper-pagination");

    if (window.innerWidth >= 600) {
      if (pagination !== null) {
        const title = this.slides[this.activeIndex].querySelector(".swiper-slide__title");

        if (title !== null) {
          const extra = (window.innerWidth < 1200) ? 25 : 50;
          const rect = title.getBoundingClientRect();
          // offsetTop = rect.top + document.body.scrollTop,
          const offsetTop = window.pageYOffset + rect.top;
          const elHeight = title.offsetHeight;
          const finalOffset = (offsetTop + elHeight) + extra;

          pagination.style.top = `${finalOffset}px`;
        }
      }
    }
  },
};

// WEBPACK FOOTER //
// ./wp-content/themes/class/resources/js/modules/HomeHeader.js
